import axios from "axios";

let cachedCitiesPromise = null;

export function getCities() {
  if (cachedCitiesPromise) {
    return cachedCitiesPromise;
  }

  // Cache response - no need to hit the API every time
  cachedCitiesPromise = axios.get(process.env.REACT_APP_API + "/cities").then((resp) => resp.data);
  return cachedCitiesPromise;
}
